import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/icon/action/eye-grey-outline.svg'
import _imports_1 from '@/assets/img/icon/action/delete.svg'


const _hoisted_1 = { class: "mr-5" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = { class: "color-grey-5" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "color-danger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      ($props.showDetail)
        ? (_openBlock(), _createElementBlock("li", {
            key: 0,
            class: "cursor-pointer py-1",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('showDetail')))
          }, [
            _createElementVNode("div", _hoisted_2, [
              _cache[2] || (_cache[2] = _createElementVNode("img", {
                src: _imports_0,
                class: "mr-3 w-4",
                alt: "edit"
              }, null, -1)),
              _createElementVNode("span", _hoisted_3, _toDisplayString($props.showDetailTitle), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ($props.del)
        ? (_openBlock(), _createElementBlock("li", {
            key: 1,
            class: "cursor-pointer py-1",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('del')))
          }, [
            _createElementVNode("div", _hoisted_4, [
              _cache[3] || (_cache[3] = _createElementVNode("img", {
                src: _imports_1,
                class: "mr-3 w-4",
                alt: "del"
              }, null, -1)),
              _createElementVNode("span", _hoisted_5, _toDisplayString($props.delTitle), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}